const STORAGE_KEY = 'chat_drafts';

interface DraftMap {
  [chatId: string]: {
    chatId: string;
    text: string;
    updatedAt: number;
  };
}

export function useChatDraft(chatId?: string) {
  function getAll(): DraftMap {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  }

  function get(): string {
    if (!chatId) return '';
    return getAll()[chatId]?.text || '';
  }

  function save(text: string) {
    if (!chatId) return;

    const drafts = getAll();

    drafts[chatId] = {
      chatId,
      text,
      updatedAt: Date.now(),
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(drafts));
  }

  function clear() {
    if (!chatId) return;

    const drafts = getAll();
    delete drafts[chatId];

    localStorage.setItem(STORAGE_KEY, JSON.stringify(drafts));
  }

  return {
    getDraft: get,
    saveDraft: save,
    clearDraft: clear,
  };
}
